import Color from 'color'
import { motion } from 'motion/react'
import { useContext } from 'react'
import { ExplorerConfigContext } from '../../providers/ExplorerConfigProvider'

interface Props {
  isSelected: boolean
}

export default function SelectionHighlighter({ isSelected }: Props) {
  const { theme } = useContext(ExplorerConfigContext)
  return (
    <motion.div
      style={{
        position: 'absolute',
        originX: '50%',
        originY: '50%',
        left: '-25%',
        top: '-25%',
        background: Color(theme.color.primary).alpha(0.1).toString(),
        height: '150%',
        width: '150%',
        borderRadius: '50%',
      }}
      animate={isSelected ? { scale: 1 } : { scale: 0 }}
      initial={isSelected}
      transition={{ ease: 'easeInOut', duration: 0.5 }}
    />
  )
}
